"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.target.client': '客户',
    'slot.target.coworker': '同事',
    'slot.target.manager': '经理',
    'slot.target.self': '我',
};
